module.exports = __webpack_public_path__ + "img/logo-sankhya.e73552aa.svg";